import { render, staticRenderFns } from "./AddTaxiDriver.vue?vue&type=template&id=2eb978d8&"
import script from "./AddTaxiDriver.vue?vue&type=script&lang=js&"
export * from "./AddTaxiDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports